import React, { useContext, useState, lazy, Suspense } from 'react';
import { node, string, bool, func } from 'prop-types';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';

const QuickViewLazy = lazy(() => import(
  '@thd-olt-component-react/quick-view'
).then((mod) => {
  const { QuickView } = mod;
  return {
    default: (props) => {
      const { defaultVariables } = props || {};
      return (
        <QueryProvider cacheKey="appliance-bundles-quick-view" defaultVariables={defaultVariables}>
          {/* eslint-disable react/jsx-props-no-spreading */}
          <QuickView {...props} />
        </QueryProvider>
      );
    }
  };
}));

export const QuickViewWrapper = ({
  children,
  itemId,
  isQuickViewOpen,
  onQuickViewClose,
}) => {
  const [fetch, setFetch] = useState(false);
  const { defaultVariables } = useContext(QueryContext) || {};
  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <>
      <div onMouseEnter={() => setFetch(true)}>
        {children}
      </div>
      {typeof window !== 'undefined' && (
        <Suspense fallback={<div />}>
          <QuickViewLazy
            isOpen={isQuickViewOpen}
            onClose={() => onQuickViewClose()}
            itemId={itemId}
            fetch={fetch}
            paginateCarousel={false}
            defaultVariables={newDefaultVariables}
          />
        </Suspense>
      )}
    </>
  );
};

QuickViewWrapper.propTypes = {
  children: node.isRequired,
  itemId: string.isRequired,
  isQuickViewOpen: bool.isRequired,
  onQuickViewClose: func.isRequired
};
